import { UserRoundSearch, Plus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { EmptyBlock } from '@/components/ui/empty-block';

import { useRepresentative } from '../model';

const EmptyRepresentatives = () => {
  const { addRepresentative, currentPolicyRole } = useRepresentative();

  return (
    <EmptyBlock
      title="No representatives added"
      icon={UserRoundSearch}
      withCard={false}
      classes={{
        content: 'h-full flex flex-col justify-center',
        title: 'text-sm',
      }}
      action={
        currentPolicyRole?.update && (
          <Button variant="secondary" onClick={addRepresentative}>
            <Plus /> Add Representative
          </Button>
        )
      }
    />
  );
};

export default EmptyRepresentatives;
